import { render, staticRenderFns } from "./adminFQAProvider.vue?vue&type=template&id=cfc2f690&scoped=true&"
import script from "./adminFQAProvider.vue?vue&type=script&lang=ts&"
export * from "./adminFQAProvider.vue?vue&type=script&lang=ts&"
import style0 from "./adminFQAProvider.vue?vue&type=style&index=0&id=cfc2f690&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc2f690",
  null
  
)

export default component.exports